<template>
  <b-modal
    ref="postModal"
    no-close-on-backdrop
    hide-footer
    v-model="showPostModal"
    @close="resetModal()"
    id="postModal"
    :title="mode == 'create' ? 'افزودن ' + title : ' ویرایش ' + title"
  >
    <b-form class="SForm">
      <template>
        <b-form-group
          v-for="(header, index) in headers"
          :key="index + 200"
          :label="header.type == 'setting' ? '' : header.name + ' :'"
          :class="header.style"
        >
          <template v-if="header.type == 'string'">
            <b-form-input
              v-model="string[header.key]"
              :ref="header.key"
              :value="editItem == null ? '' : editItem[header.key]"
              :placeholder="header.placeholder"
            ></b-form-input>
          </template>
          <template v-if="header.type == 'boolean'">
            <b-form-checkbox switch v-model="booleans[header.key]">
              {{ header.placeholder }}
            </b-form-checkbox>
          </template>
          <template v-if="header.type == 'image'">
            <b-form-file
              v-model="files[header.key]"
              :state="Boolean(files[header.key])"
              :placeholder="header.placeholder"
              :drop-placeholder="header.placeholder"
            ></b-form-file>
          </template>
          <template v-if="header.type == 'description'">
            <b-form-textarea
              v-model="description[header.key]"
              :value="editItem == null ? '' : editItem[header.key]"
              :drop-placeholder="header.placeholder"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </template>
          <template v-if="header.type == 'file'">
            <b-form-file
              v-model="files[header.key]"
              :state="Boolean(files[header.key])"
              :placeholder="header.placeholder"
              :drop-placeholder="header.placeholder"
            >
            </b-form-file>
          </template>
          <template v-if="settings != null && header.type == 'select'">
            <treeselect
              :multiple="header.multiple"
              :clearable="false"
              :searchable="true"
              v-model="selected[header.key]"
              :options="settings[header.selectIN]"
            />
          </template>

          <template v-if="header.type == 'list'">
            <b-form-input
              v-model="listName[header.key]"
              placeholder="محتوا را وارد کنید "
              @keypress.enter="addToList(header.key)"
            >
            </b-form-input>
            <b-button
              type="button"
              class="col-10 insertBtn"
              variant="info"
              @click.prevent="addToList(header.key)"
              >افزودن</b-button
            >
            <table
              v-if="listValue[header.key] != undefined"
              class="table table-hover"
            >
              <tr>
                <th>مقدار</th>
                <th>حذف</th>
              </tr>
              <template>
                <tr
                  v-for="item in listValue[header.key]"
                  :key="item.id"
                  :id="`tr${item.id}`"
                >
                  <td>
                    {{ item.value }}
                  </td>
                  <td>
                    <b-button
                      class="tableButtons"
                      variant="danger"
                      @click="deleteValueFromInsertList(item.id, header.key)"
                      >حذف</b-button
                    >
                  </td>
                </tr>
              </template>
            </table>
          </template>
          <template v-if="settings != null && header.type == 'specifications'">
            <treeselect
              :multiple="true"
              :clearable="false"
              :searchable="false"
              v-model="specification"
              :options="settings[header.selectIN]"
            />
            <div
              v-if="specification != null && specification.length > 0"
              class="col-12"
            >
              <template v-for="item in selectedSpecificationList">
                <b-form-group
                  class="mrbt col-12"
                  :key="item.id"
                  :label="item.label + ' :'"
                >
                  <b-form-textarea
                    v-if="item.type == 'text'"
                    rows="3"
                    max-rows="6"
                    v-model="selectedSpecification[item.name]"
                  >
                  </b-form-textarea>
                  <treeselect
                    v-else
                    :multiple="item.type == 'multi_select' ? true : false"
                    :clearable="false"
                    :searchable="false"
                    v-model="selectedSpecification[item.name]"
                    :options="item.values"
                  />
                </b-form-group>
              </template>
            </div>
          </template>
          <template v-if="header.type == 'ckEditor'">
            <ckeditor
              :editor="editor"
              v-model="editorData"
              :config="editorConfig"
            ></ckeditor>
          </template>
          <template v-if="header.type == 'menu_link'">
            <div>
              <b-form-input
                :disabled="!show_Link"
                v-model="menuLink"
                :placeholder="header.placeholder"
              ></b-form-input>
            </div>
          </template>
          <template v-if="header.type == 'menu_select'">
            <treeselect
              :multiple="false"
              :clearable="false"
              :searchable="true"
              v-model="menuSelected"
              :options="settings[header.selectIN]"
            />
          </template>
          <template v-if="header.type == 'menu_detail_select'">
            <treeselect
              :disabled="show_Link"
              :multiple="false"
              :clearable="false"
              :searchable="true"
              v-model="menuDetailSelected"
              :options="menuDetail"
            />
          </template>
        </b-form-group>

        <img
          class="image_in_form"
          v-if="editItem != null && editItem.image != undefined"
          :src="editItem.image"
        />
      </template>
      <!-- در صورت زیاد بودن تعداد فیلد ها دو ستون تشکیل بده -->

      <div class="form_btn col-12">
        <b-button
          v-if="disabled == false"
          @click.prevent="submitForm()"
          type="button"
          variant="primary"
          >{{ mode == "create" ? "ارسال" : "ویرایش" }}</b-button
        >
        <b-button v-else class="disbledLink" type="button" variant="primary">{{
          mode == "create" ? "در حال ارسال" : "درحال ویرایش"
        }}</b-button>
      </div>
    </b-form>
    <!-- /.card-body -->
  </b-modal>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import mixin from "@/mixins/mixins.js";
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BRow,
  BFormFile,
  BFormCheckbox,
  BCol,
  BFormTextarea
} from "bootstrap-vue";

export default {
  mixins: [mixin],

  methods: {
    deleteValueFromInsertList(id, key) {
      this.listValue[key] = this.listValue[key].filter((item) => {
        return item.id != id;
      });
      document.getElementById(`tr${id}`).style.display = "none";
    },
    addToList(key) {
      this.helpIndex++;
      if (this.listValue[key] == undefined) {
        this.listValue[key] = [];
      }
      this.listValue[key].push({
        value: this.listName[key],
        id: this.helpIndex
      });
      this.listName[key] = "";
    },
    submitForm() {
      let form_data = new FormData();
      this.headers.forEach((header) => {
        if (header.type == "string") {
          if(header.key=="publish_year"){
            if(this.string[header.key]==undefined || this.string[header.key]==""){
              form_data.append(`${header.key}`, "بیتا");
            }else{
              form_data.append(`${header.key}`, this.string[header.key]);
            }
          }else{
            form_data.append(`${header.key}`, this.string[header.key]);
          }
        } else if (header.type == "description") {
          form_data.append(`${header.key}`, this.description[header.key]);
        } else if (header.type == "boolean") {
          form_data.append(
            `${header.key}`,
            this.booleans[header.key] == true ? 1 : 0
          );
        } else if (header.type == "image" || header.type == "file") {
          form_data.append(
            `${header.key}`,
            this.files[header.key] != undefined ? this.files[header.key] : ""
          );
        } else if (header.type == "select") {
          if (header.multiple) {
            if (this.selected[header.key] != undefined) {
              this.selected[header.key].forEach((item, index) => {
                console.log(item);
                form_data.append(`${header.key}[${index}]`, item);
              });
            }
          } else {
            form_data.append(
              `${header.key}`,
              this.selected[header.key] != undefined
                ? this.selected[header.key]
                : ""
            );
          }
        } else if (header.type == "list") {
          if (this.listValue[header.key] != undefined &&this.listValue[header.key].length>0) {
            this.listValue[header.key].forEach((item, index) => {
              form_data.append(`${header.key}[${index}]`, item.value);
            });
          }
        } else if (header.type == "ckEditor") {
          form_data.append(`${header.key}`, this.editorData);
        } else if (header.type == "specifications") {
          if (this.selectedSpecificationList.length > 0) {
            this.selectedSpecificationList.forEach((item, index) => {
              if (item.type == "multi_select") {
                form_data.append(`${header.key}[${index}][id]`, item.id);
                let helpList = [];
                item.values.forEach((val) => {
                  if (
                    this.selectedSpecification[item.name].find((id) => {
                      return id == val.id;
                    })
                  ) {
                    helpList.push(val.value);
                  }
                });
                helpList.forEach((vl) => {
                  form_data.append(`${header.key}[${index}][value][]`, vl);
                });
              } else if (item.type == "select") {
                form_data.append(`${header.key}[${index}][id]`, item.id);
                item.values.forEach((val) => {
                  if (val.id == this.selectedSpecification[item.name]) {
                    form_data.append(
                      `${header.key}[${index}][value]`,
                      val.value
                    );
                  }
                });
              } else {
                form_data.append(`${header.key}[${index}][id]`, item.id);

                form_data.append(
                  `${header.key}[${index}][value]`,
                  this.selectedSpecification[item.name]
                );
              }
            });
          }
        } else if (header.type == "menu_link") {
          form_data.append(
            `${header.key}`,
            this.menuSelected == null ? this.menuLink : ""
          );
        } else if (header.type == "menu_select") {
          if (this.menuSelected == null) {
            form_data.append(`linkable_type`, "");
          } else {
            this.settings.linksData.forEach((link) => {
              if (link.label == this.menuSelected) {
                form_data.append(`linkable_type`, link.linkable_type);

                if (link.models == null) {
                  form_data.append(`linkable_id`, "");
                } else {
                  form_data.append(`linkable_id`, this.menuDetailSelected);
                }
              }
            });
          }
          form_data.append(`group_id`, this.settings.group_id);
        }
      });
      this.$emit("submit", form_data);
    }
  },
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BRow,
    BFormFile,
    BFormCheckbox,
    BCol,
    BFormTextarea
  },
  props: {
    title: String,
    specificationList: Array,
    settings: Object,
    mode: String,
    headers: Array,
    edit_item: Object,
    showPostModal: Boolean,
    disabled: Boolean
  },
  watch: {
    menuSelected(newVal) {
      this.show_Link = newVal == null ? true : false;
      this.settings.linksData.forEach((link) => {
        if (link.label == newVal) {
          if (link.models == null) {
            this.menuDetail = [];
          } else {
            let models = [];
            link.models.forEach((model) => {
              models.push({
                id: model.id,
                label: model.name != undefined ? model.name : model.title
              });
            });
            this.menuDetail = models;
          }
        }
      });
    },
    edit_item(newVal) {
      console.log(newVal.specifications);
      if (newVal == null) return;
      this.editItem = newVal;
      this.headers.forEach((header) => {
        if (header.type == "boolean") {
          this.booleans[header.key] = newVal[header.key] == 0 ? false : true;
        }
        if (header.type == "list") {
          this.listValue[header.key] = [];
          newVal[header.key].forEach((item, index) => {
            this.listValue[header.key].push({
              value: item.name.fa,
              id: index
            });
            this.helpIndex = index + 1;
          });
        }
        if (header.type == "select") {
          if (header.multiple == false) {
            this.selected[header.key] = newVal[header.key];
          } else {
            if (newVal[header.key] != null) {
              let helpArr = [];
              newVal[header.key].forEach((item) => {
                helpArr.push(item.id);
              });
              this.selected[header.key] = helpArr;
            }
          }
        }
        if (header.type == "specifications") {
          this.selectedSpecificationList = [];
          this.selectedSpecification = [];
          let specificationHelp = [];
          newVal.specifications.forEach((spe) => {
            specificationHelp.push(spe.id);
            if (spe.type == "text") {
              this.selectedSpecification[spe.name] = spe.pivot.value;
            } else if (spe.type == "select") {
              this.selectedSpecification[spe.name] = spe.pivot.value_id;
            } else {
              let vlStr = spe.pivot.value;
              let valueArray = vlStr.split(",");
              let speSelected = this.settings.specificationList.filter(
                (item) => {
                  if (item.id == spe.id) {
                    return item;
                  }
                }
              );

              this.selectedSpecification[spe.name] = [];
              speSelected[0].values.forEach((val) => {
                if (valueArray.includes(val.value)) {
                  this.selectedSpecification[spe.name].push(val.id);
                }
              });
            }
          });
          console.log(
            "🚀 ~ file: postModal.vue ~ line 455 ~ newVal.specifications.forEach ~ newVal.specifications",
            newVal.specifications
          );
          console.log(
            "🚀 ~ file: postModal.vue ~ line 455 ~ newVal.specifications.forEach ~ newVal.specifications",
            newVal.specifications
          );
          this.specification = specificationHelp;
        }
        if (header.type == "ckEditor") {
          this.editorData = newVal[header.key];
        }
        if (header.type == "menu_select") {
          if (newVal.linkable_type != "" && newVal.linkable_type != null) {
            this.settings.linksData.forEach((link) => {
              if (link.linkable_type == newVal.linkable_type) {
                this.menuSelected = link.label;
              }
            });
            if (newVal.linkable_id != "" && newVal.linkable_id != null) {
              this.menuDetailSelected = newVal.linkable_id;
            }
          } else {
            this.menuSelected = null;

            this.menuLink = newVal.link;
          }
        }
        if (header.type == "string") {
          this.string[header.key] = newVal[header.key];
        }
             if (header.type == "description") {
          this.description[header.key] = newVal[header.key] ;
        }
      });
    },
    showPostModal(newVal) {
      if (newVal == true) {
        this.headers.forEach((header) => {
          if (
            this.booleans[header.key] != undefined &&
            this.editItem != undefined
          ) {
            this.booleans[header.key] =
              this.editItem[header.key] == 1 ? true : false;
          }
        });
      }
    },
    specification(newVal) {
      this.selectedSpecificationList = this.specificationList.filter((item) => {
        return newVal.includes(item.id);
      });
    }
  },
  data() {
    return {
      string: {},
      description: {},
      menuLink: null,
      menuDetail: [],
      menuDetailSelected: null,
      show_Link: true,
      menuSelected: null,
      editItem: this.edit_item,
      specification: null,
      selectedSpecification: {},
      selectedSpecificationList: [],
      files: {},
      booleans: {},
      selected: {},
      listName: {},
      listValue: {},
      helpIndex: 1,
      editor: ClassicEditor,
      editorData: "<p>محتوا را وارد کنید</p>",
      editorConfig: {
        language: "fa"
      }
    };
  }
};
</script>
<style scoped>
.disbledLink {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.image_in_form {
  width: 50%;
  transform: translateX(-50%);
}
.SForm {
  display: flex;
  flex-wrap: wrap;
}
.insertBtn {
  margin: 20px;
}
.mrbt {
  margin: 10px 0;
}
</style>
